import React, { useEffect, useRef, useState } from "react";


import Swal from "sweetalert2";

import { browserName } from "react-device-detect";
import logo from "./logo.svg";
import "./App.css";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Header from "./views/common/Header";
import Hero from "./views/Landing/Hero";
import { Element } from "react-scroll";
import About from "./views/Landing/About";
import Footer from "./views/common/Footer";
import AuthLogin from "./views/Authenticator/AuthLogin";
import AuthSignup from "./views/Authenticator/AuthSignup";
import AuthDashboard from "./views/Authenticator/AuthDashboard";
import Pattern from "./views/Pattern";
import OnlineExam from "./views/OnlineExam";
import FinalSubmit from "./views/FinalSubmit";
import TestAnalysis from "./views/TestAnalysis";
import AuthAdminLogin from "./views/Authenticator/AuthAdminLogin";
import AdminDashboard from "./views/AdminDashboard";
import AuthAdminDashboard from "./views/Authenticator/AuthAdminDashboard";
import Countdown from "react-countdown";
import ToasterProvider from "./Providers/ToasterProvider";
import HomePage from "./views/HomePage";

import ContactUs from "./views/Dashboard/contacts";
import {
  ExamResultDetailsTypes,
  QuestionResponse,
} from "./types/onlineExam.interface";

import { IllegalActivityEnum } from "./utils";
import {
  NotificationOptions,
  SubmissionStatusEnum,
  visibilityDownNotificationIntervalTime,
  visibilityDownTime,
} from "./environment";
import Main from "./views/Main";
import IntermediatePage from "./views/AdminDashboard/IntermediatePage";
import useUserStore from "./stores/useUserStores";
import { UserContext } from "./context/UserContext";
import FullscreenWarningModal from "./components/FullScreenWarningModal";
import { set } from "lodash";

//  ***************************   Polyfills of  groupBy method of array  ****************************  ///
type FuncType = (param: any) => any;

declare global {
  interface Array<T> {
    customGroupBy<T>(keyFinder: T | keyof T | FuncType): any;
  }
}
// ****************************  Some hidden talents of our  mighty & lovely Javascript ************** ///
Array.prototype.customGroupBy = function <T>(keyFinder: keyof T | FuncType) {
  return (this as Array<T>).reduce((acc: any, curr: T) => {
    const key =
      typeof keyFinder === "function"
        ? keyFinder(curr)
        : !!curr && typeof curr === "object"
        ? curr[keyFinder]
        : curr;
    acc[key] = !acc?.[key] ? [curr] : [...acc[key], curr];
    return acc;
  }, {});
};

function App() {
  const visibilitycountDownRef = useRef<number>(visibilityDownTime);

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if ((element as any).mozRequestFullScreen) {
      (element as any).mozRequestFullScreen();
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
    }
  };

  const handleFullscreenChange = () => {
    //   if(!examStarted){
    //     if(fullscreenchangeRef.current){
    //       clearInterval(fullscreenchangeRef.current);
    //     }
    //     return;
    //   }
    //  fullscreenchangeRef.current = setInterval(() => {
    //     if (document.fullscreenElement) {
    //     if(!fullscreenmode)  setFullScreenMode(true);
    //     } else {
    //    if(fullscreenmode)    setFullScreenMode(false);
    //     }
    //     if (
    //       (window.screen.availHeight || window.screen.height - 30) <=
    //       window.innerHeight
    //     ) {
    //       if(!fullscreenmode)  setFullScreenMode(true);
    //     } else {
    //        if(fullscreenmode) setFullScreenMode(false);
    //     }
    //   }, 2000);
  };

  // // Visivility Change
  const onVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };
  const {
    userdetail,
    setuserdetail,
    islogin,
    setislogin,
    isAdmin,
    setisAdmin,
    setToken,
    token,
    loading,
    setLoading,
    fullscreenmode,
    setFullScreenMode,
    // enterFullscreen,
    setExam,
    exam,
    setOfflineExamLineInformation,
    offlineExamInformation,
    setResultUploadedForOfflineCentre,
    isResultIsUploaded,
    setIsResultUploadedUploadedForOfflineCentre,
    isResultUploadedForOfflineCentre,
    endTimeOfExams,
    setEndTimeOfExams,
    setisTestCentreAdmin,
    isTestCentreAdmin,
    setIsQuestionSynced,
    isQuestionSynced,
    setTests,
    tests,
    isVisible,
    setIsVisible,
    setExamStarted,
    setWindowFocused,
    showWarningModalForFulScreen,
    setShowFullScreenCountDown,
    setShowWarningModalForFullscreen,
    fullscreenCountDown,
    windowFocused,
    examStarted,
    examQuestionDetails,
    setExamQuestionDetails,
    setStartExamMessage,
    startExamMessage,
    //handleFullscreenChange,
    selectedExamGroup,
    setSelectedExamGroup,
    setExamResultDetails,
    examResultDetails,
    resultOfExamPapers,
    setResultOfExamPapers,
    closeMyExam,
    setCloseMyExam,
    submissionStateType,
    setSubmissionStateType,
    resumeDuration,
    setResumeDuration,
  } = useUserStore();
  const values = {
    // userdetail,
    // setuserdetail,
    // islogin,
    // setislogin,
    // isAdmin,
    // setisAdmin,
    // setToken,
    // token,
    // loading,
    // setLoading,
    // fullscreenmode,
    // setFullScreenMode,
    enterFullscreen,
    // setExam,
    // exam,
    // setOfflineExamLineInformation,
    // offlineExamInformation,
    // setResultUploadedForOfflineCentre,
    // isResultIsUploaded,
    // setIsResultUploadedUploadedForOfflineCentre,
    // isResultUploadedForOfflineCentre,
    // endTimeOfExams,
    // setEndTimeOfExams,
    // setisTestCentreAdmin,
    // isTestCentreAdmin,
    // setIsQuestionSynced,
    // isQuestionSynced,
    // setTests,
    // tests,
    // isVisible,
    // setIsVisible,
    // setExamStarted,
    // examStarted,
    // examQuestionDetails,
    // setExamQuestionDetails,
    // setStartExamMessage,
    // startExamMessage,
    handleFullscreenChange,
    // selectedExamGroup,
    // setSelectedExamGroup,
    // setExamResultDetails,
    // examResultDetails,
    // resultOfExamPapers,
    // setResultOfExamPapers,
    // closeMyExam,
    // setCloseMyExam,
    // submissionStateType,
    // setSubmissionStateType,
    // resumeDuration,
    // setResumeDuration,
  };

  // useEffect(() => {
  //   if (!!userdetail && !!token && !!examStarted) {
  //     document.addEventListener("visibilitychange", onVisibilityChange, false);
  //   }
  //   return () => {
  //     document.addEventListener("visibilitychange", onVisibilityChange, false);
  //   };
  // }, [token, userdetail, examStarted]);

  // useEffect(() => {
  //   // Set the initial visibility state
  //   if (!!userdetail && !!token && !!examStarted) {
  //     setIsVisible(document.hasFocus());
  //   }

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     setIsVisible(document.hasFocus());
  //   };
  // }, [userdetail, token, examStarted, document.hasFocus()]);

  // useEffect(() => {
  //   if (!("Notification" in window)) {
  //   } else {
  //     Notification.requestPermission();
  //   }
  // }, [token, fullscreenmode, isVisible]);

  // const senseVisibilityFn = () => {
  //   try {
  //     if (document.visibilityState === "hidden" && token && examStarted) {
  //       if (!("Notification" in window)) {
  //       } else {
  //         Notification.requestPermission();
  //       }

  //       visibilityCounterRef.current = setInterval(() => {
  //         visibilitycountDownRef.current = visibilitycountDownRef.current
  //           ? visibilitycountDownRef.current - 1
  //           : 0;
  //         if (visibilitycountDownRef.current === 0) {
  //           setCloseMyExam(true);
  //           new Notification("Exam Terminated", {
  //             body: `The examination browser was minimized or hidden or blur during the test. Your session has been terminated, and your answers submitted for review.`,
  //             icon: "/alert-icon-red-11-removebg-preview.png",
  //             dir: "ltr",
  //           });
  //           clearInterval(visibilityCounterRef.current);
  //           if (invisibleAlertRef.current) {
  //             clearInterval(invisibleAlertRef.current);
  //           }
  //         }
  //         if (
  //           document.visibilityState !== "hidden" &&
  //           visibilitycountDownRef.current >= 1
  //         ) {
  //           visibilitycountDownRef.current = visibilityDownTime;
  //           if (visibilityCounterRef.current) {
  //             clearInterval(visibilityCounterRef.current);
  //           }
  //           if (invisibleAlertRef.current) {
  //             clearInterval(invisibleAlertRef.current);
  //           }
  //         }
  //       }, 1000);

  //       //  if n  second timer is completed then close my exam
  //       if (visibilitycountDownRef.current === 0) {
  //         setCloseMyExam(true);
  //         if (visibilityCounterRef.current) {
  //           clearInterval(visibilityCounterRef.current);
  //         }
  //         if (invisibleAlertRef.current) {
  //           clearInterval(invisibleAlertRef.current);
  //         }
  //       }
  //       new Notification("Alert Message", {
  //         body:
  //           visibilitycountDownRef.current === 0
  //             ? `The examination browser was minimized or hidden or blur during the test. Your session has been terminated, and your answers submitted for review.`
  //             : `If you do not return back in your examination within the next ${
  //                 visibilitycountDownRef.current ?? 7
  //               } second, your answers will be automatically submitted.`,
  //         icon: "/alert-icon-red-11-removebg-preview.png",
  //         dir: "ltr",
  //       });
  //       //setVisibilityDeadline(Date.now());

  //       invisibleAlertRef.current = setInterval(() => {
  //         new Notification("Alert Message", {
  //           body:
  //             visibilitycountDownRef.current === 0
  //               ? `The examination browser was minimized or hidden or during during the test. Your session has been terminated, and your answers submitted for review.`
  //               : `If you do not return back in your examination within the next ${
  //                   visibilitycountDownRef.current ?? visibilityDownTime
  //                 } second, your answers will be automatically submitted.`,
  //           icon: "/alert-icon-red-11-removebg-preview.png",
  //           dir: "ltr",
  //         });
  //       }, visibilityDownNotificationIntervalTime * 1000);
  //     }
  //     // <<<<<<<<<<<<<<<<<<<<<<<< If Examinee comes again in visible state within 7 second then do this  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  //     if (
  //       document.visibilityState !== "hidden" &&
  //       visibilitycountDownRef.current >= 1
  //     ) {
  //       visibilitycountDownRef.current = visibilityDownTime;
  //       if (invisibleAlertRef.current) clearInterval(invisibleAlertRef.current);

  //       if (visibilityCounterRef.current)
  //         clearInterval(visibilityCounterRef.current);
  //       //  setVisibilityDeadline(-1);
  //     }
  //     return () => {
  //       //setVisibilityDeadline(-1);
  //       if (
  //         document.visibilityState !== "hidden" &&
  //         visibilitycountDownRef.current >= 1
  //       ) {
  //         visibilitycountDownRef.current = visibilityDownTime;
  //       }

  //       if (invisibleAlertRef.current) clearInterval(invisibleAlertRef.current);
  //       if (visibilityCounterRef.current)
  //         clearInterval(visibilityCounterRef.current);
  //     };
  //   } catch (error) {}
  // };

  // **********************************************    Window Minimize Option  ***************************************** //

  // ***************************    Sense document is focussed or not     **********************************
  // useEffect(() => {
  //   if (examStarted && token)
  //     document.addEventListener("visibilitychange", senseVisibilityFn);
  //   return () => {
  //     document.removeEventListener("visibilitychange", senseVisibilityFn);
  //   };
  // }, [isVisible, examStarted, token, windowFocused]);

  const renderer = ({ hours, minutes, seconds, completed }: any) => {
    if (completed) {
      // setuserdetail(undefined);
      // setislogin(false);
      // setToken(undefined);
      setCloseMyExam(true);
      return <></>;
    } else {
      return (
        <span style={{ fontWeight: "bold", color: "red" }}>
          {hours < 10 ? `0${hours}` : hours}:
          {minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
      );
    }
  };

  const visibilityRenderer = ({ hours, minutes, seconds, completed }: any) => {
    if (completed) {
      // setuserdetail(undefined);

      setCloseMyExam(true);
      return <></>;
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    if (
      ["/test/finalresult", "/", "/login", "/Dashboard/test-series"].includes(
        window.location.pathname
      )
    ) {
      visibilitycountDownRef.current = 7;
    }
  }, [window.location.pathname]);

  useEffect(() => {
    window.onblur = function (event: any) {
      setWindowFocused(false);
    };
    window.onfocus = function (event: any) {
      setWindowFocused(true);
    };
  }, []);

  return (
    <UserContext.Provider value={values}>
      <ToasterProvider />

      {/* {
        document.visibilityState === "hidden" && examStarted ? (
          <Countdown renderer={visibilityRenderer} date={Date.now() + 10000} />

        ):(
          <></>
        )
      } */}

      <Router>
        <Routes>
          <Route
            path="/"
            element={
              !!userdetail && userdetail.userType === "ADMIN" ? (
                <Navigate replace to={"/admin-dashboard/create-list"} />
              ) : !!userdetail && userdetail.userType === "TCADMIN" ? (
                <Navigate replace to={"/admin-dashboard/"} />
              ) : (
                // <HomePage />
                <Main />
              )
            }
          />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/login" element={<AuthLogin />} />
          <Route path="/Signup" element={<AuthSignup />} />
          <Route path="/dashboard/*" element={<AuthDashboard />} />
          <Route path="/test/marking-scheme" element={<Pattern />} />
          <Route path="/test/ongoing" element={<OnlineExam />} />
          <Route path="/test/finalresult" element={<FinalSubmit />} />
          <Route path="/test/test-analysis" element={<TestAnalysis />} />
          {/* <Route path="/test-starting" element={<IntermediatePage />} /> */}
          <Route path="/admin-login" element={<AuthAdminLogin />} />
          <Route path="/admin-login-centerwise" element={<AuthAdminLogin />} />
          <Route path="/admin-dashboard/*" element={<AuthAdminDashboard />} />

          <Route path="*" element={<AuthLogin />} />
          {/* <Route path="/Forgotpassword" element={<AuthForgetPass />} />
            <Route path="/verifyotp" element={<AuthForgetVerifyOTP />} />
            
            
            
             */}
        </Routes>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
